<template>
<div class="chapter">
<div class="inner_page">
<p class="C600"><em><span id="page_xii">Note </span>on Translations </em></p>
<p class="P31">In the interest of accessibility, all foreign-language texts appear in translation. I have used published translations where they exist; all other translations are my own. </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 07_Note_on.vue?959f9d0a